import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';

export default mutatorAction('SET_REMINDER_SOUND_ENABLED', (isEnabled: boolean) => {
    getStore().reminderSound = isEnabled;
});
